module.exports = {
      id: "comment-usage",
      viewBox: "0 0 14 15",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#comment",
      toString: function () {
        return this.url;
      }
    }